/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaterialDetailsDto } from '../../models/material-details-dto';
import { Operation } from '../../models/operation';

export interface PatchMaterial$Params {
  id: number;
  'X-API-Version'?: string;
      body: Array<Operation>
}

export function patchMaterial(http: HttpClient, rootUrl: string, params: PatchMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<MaterialDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, patchMaterial.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MaterialDetailsDto>;
    })
  );
}

patchMaterial.PATH = '/api/materials/{id}';
